import { render, staticRenderFns } from "./GroupsUpdateDoc.vue?vue&type=template&id=6dab412a"
import script from "./GroupsUpdateDoc.vue?vue&type=script&lang=js"
export * from "./GroupsUpdateDoc.vue?vue&type=script&lang=js"
import style0 from "./GroupsUpdateDoc.vue?vue&type=style&index=0&id=6dab412a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports